// Maps category names to semantic display groups for the category picker
// Order matters — first match wins, groups are displayed in this order

const GROUP_KEYWORDS = [
  {
    group: 'Food & Dining',
    keywords: ['food', 'dining', 'restaurant', 'groceries', 'grocery', 'coffee', 'cafe', 'snack', 'meal', 'lunch', 'dinner', 'breakfast', 'bakery', 'sweets', 'kitchen']
  },
  {
    group: 'Shopping',
    keywords: ['shopping', 'clothes', 'clothing', 'fashion', 'amazon', 'flipkart', 'online', 'electronics', 'gadget', 'jewelry', 'accessories', 'shoes', 'mall']
  },
  {
    group: 'Transport',
    keywords: ['transport', 'travel', 'car', 'auto', 'fuel', 'petrol', 'gas', 'uber', 'ola', 'taxi', 'metro', 'train', 'bus', 'flight', 'parking', 'bike', 'vehicle', 'toll']
  },
  {
    group: 'Bills & Utilities',
    keywords: ['electric', 'water', 'internet', 'wifi', 'phone', 'mobile', 'recharge', 'utility', 'utilities', 'maintenance', 'gas bill', 'bill', 'rent', 'emi', 'loan', 'insurance', 'tax', 'fees']
  },
  {
    group: 'Health & Fitness',
    keywords: ['health', 'medical', 'medicine', 'pharmacy', 'doctor', 'hospital', 'gym', 'fitness', 'yoga', 'sports', 'wellness', 'dental', 'eye']
  },
  {
    group: 'Entertainment',
    keywords: ['entertainment', 'movie', 'netflix', 'streaming', 'subscription', 'music', 'spotify', 'gaming', 'game', 'party', 'event', 'concert', 'outing']
  },
  {
    group: 'Education',
    keywords: ['education', 'school', 'college', 'course', 'book', 'tuition', 'training', 'study', 'exam', 'class', 'library']
  },
  {
    group: 'Personal Care',
    keywords: ['salon', 'haircut', 'spa', 'beauty', 'grooming', 'personal care', 'skincare', 'cosmetic']
  },
  {
    group: 'Home',
    keywords: ['home', 'house', 'furniture', 'decor', 'appliance', 'kitchen', 'garden', 'cleaning']
  },
  {
    group: 'Family & Pets',
    keywords: ['kids', 'baby', 'children', 'toys', 'family', 'pet', 'dog', 'cat', 'vet', 'child']
  },
  {
    group: 'Finance',
    keywords: ['investment', 'saving', 'dividend', 'interest', 'bank', 'mutual fund', 'stock', 'crypto', 'trading']
  },
  {
    group: 'Income',
    keywords: ['salary', 'wage', 'income', 'bonus', 'freelance', 'rental', 'refund', 'cashback', 'reward', 'commission', 'profit', 'revenue', 'business']
  },
  {
    group: 'Gifts & Charity',
    keywords: ['gift', 'charity', 'donation', 'tips', 'tithe']
  },
];

// Group display order
const GROUP_ORDER = [
  'Food & Dining', 'Shopping', 'Transport', 'Bills & Utilities',
  'Health & Fitness', 'Entertainment', 'Education', 'Personal Care',
  'Home', 'Family & Pets', 'Finance', 'Income', 'Gifts & Charity', 'Other'
];

/**
 * Get the semantic group for a category name
 */
export function getCategoryGroup(categoryName) {
  if (!categoryName) return 'Other';
  const lower = categoryName.toLowerCase().trim();

  for (const { group, keywords } of GROUP_KEYWORDS) {
    for (const keyword of keywords) {
      if (lower.includes(keyword) || keyword.includes(lower)) {
        return group;
      }
    }
  }
  return 'Other';
}

/**
 * Group categories into ordered sections
 * @param {Array} categories - Array of category objects with name, icon, color
 * @returns {{ groups: string[], categoriesByGroup: Object }}
 */
export function groupCategories(categories) {
  const byGroup = {};

  for (const cat of categories) {
    const group = getCategoryGroup(cat.name);
    if (!byGroup[group]) byGroup[group] = [];
    byGroup[group].push(cat);
  }

  // Sort each group alphabetically
  for (const group of Object.keys(byGroup)) {
    byGroup[group].sort((a, b) => a.name.localeCompare(b.name));
  }

  // Return groups in display order, skip empty
  const orderedGroups = GROUP_ORDER.filter(g => byGroup[g]?.length > 0);

  return { groups: orderedGroups, categoriesByGroup: byGroup };
}
